export default __webpack_public_path__ + "static/media/hejun.c28d799d.png";